import ModalContent from './ModalContent.js';
import ToggleFavs from "./ToggleFavs";

export default function Modal(props) {

    function isModalHidden() {
        //function that determines what css to render for modal visibility property
        if (props.isHidden) {
            const modalStyle = {
                visibility: 'hidden'
            }
            return modalStyle;
        } else {
            const modalStyle = {
                visibility: 'visible'
            }
            return modalStyle;
        }
    }
    const handleCloseModal = () => {
        props.setIsHidden(true);
        //console.log('window.location:', window.location);
    }


    // Added because if the html element is simply hidden then when
    // I add black adam to favorites it adds every movie to favorite
    // because the star below that element is stacked with the stars
    // of other modals. Pretty bad explanation just ask me if my 
    // explenation wasn't good enough.
    if (props.isHidden === true) {
        return (<span></span>)
    }

    return (
        <div className="row w-100 text-dark">
            <div className="modal" style={isModalHidden()}>
                <div className="popupbox d-flex justify-content-center align-content-center flex-column">
                    <div className="modal-options">
                        <ToggleFavs id={props.movieModal != null && props.movieModal}/>
                        <button className="btn btn-danger close-btn" onClick={() => handleCloseModal()}>Close</button>
                    </div>
                    <ModalContent movieModal={props.movieModal} setMovieModal={props.setMovieModal} />
                </div>
            </div>
        </div>
    )
}